import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Blind_Sample_Table from "./blind_sample_table/Blind_Sample_Table";
import Blind_Sample_Filter from "./blind_sample_filter/Blind_Sample_Filter";


const Blind_Sample = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
    

      <div className="Sample_Report_Filter_div">
        <Blind_Sample_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Blind_Sample_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Measurement Uncertainty Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Blind_Sample;
